import { createContext } from "react";

const ResultadosReaContext = createContext();

export default ResultadosReaContext;
